import React from "react";
import { json } from "react-router-dom";

export default function TextReportHeader() {
// Initialise the Array

  const arrayString = localStorage.getItem("UpdatedDataArray");
  const array = JSON.parse(arrayString);
  
  function handlenumberconditions(chosenOption, comparisonValue, jsonObject){
    if (chosenOption<comparisonValue){
      return jsonObject["lesser"]
    }
    else {
      return jsonObject["greater"]
    }
}
  function handleDateConditions(chosenOption, comparisonValue, jsonObject) {
    // Convert chosenOption and comparisonValue to Date objects if they are not already
    if (!(chosenOption instanceof Date)) {
      chosenOption = new Date(chosenOption);
    }
    if (!(comparisonValue instanceof Date)) {
      comparisonValue = new Date(comparisonValue);
    }

    if (chosenOption > comparisonValue) {
      let z = jsonObject["greater"];
      if (typeof z === "string" && z.includes("[value]")) {
        z = z.replace("[value]", chosenOption.toDateString());
        return z;
      }
      return jsonObject["greater"];
    }

    let z = jsonObject["lesser"];
    if (typeof z === "string" && z.includes("[value]")) {
      z = z.replace("[value]", chosenOption.toDateString());
      return z;
    }

    return jsonObject["lesser"];
  }

 // Fetch data and process it to generate textReportHeader
  const objectChosen = array
    .filter(
      (obj) =>
        obj["Value (per property)"] !== "" &&
        obj["ValueOptions (per property) with report output. Maybe this can be used to map value options to report output."] !== ""
    )
    .map((obj) => {
      const category = obj["Category (per property)"];
      const property = obj["Property"];
      const valueOptions = obj[ "ValueOptions (per property) with report output. Maybe this can be used to map value options to report output."];
      var jsonString = valueOptions.replace(/\n/g, ", ");
      const keyValuePairs = jsonString.split(", ");
      const jsonObject = {};
      keyValuePairs.forEach((pair) => {
        const [key, value] = pair.split(": ").map(val => val.replace(/\./g, ''));
        if (key.indexOf(">") > -1) jsonObject["greater"] = value + '.';
        else if (key.indexOf("<") > -1) jsonObject["lesser"] = value + '.';
        else jsonObject[key] = value + '.';
      });
      const chosenOption = obj["Value (per property)"];

      if (valueOptions.indexOf(">") > -1 || valueOptions.indexOf("<") > -1) {
        if (valueOptions.includes("date")) {
          const currentDate = new Date();
          return {category, property, reportData: handleDateConditions(chosenOption, currentDate, jsonObject),};
        } 
        else {
          let comparisonValue;
          keyValuePairs.forEach((pair) => {
            const [key, value] = pair.split(": ");
            let a;
            if (key.indexOf(">") > -1) a = key.split(">");
            else if (key.indexOf("<") > -1) a = key.split("<");
            const b = a[1];
            comparisonValue = parseInt(b);
          });
          return {category, property, reportData: handlenumberconditions(chosenOption, comparisonValue, jsonObject),};
        }
      } else {
        let reportData;

        if (jsonObject[chosenOption] === undefined) {
          reportData = chosenOption;
        } else {
          reportData = jsonObject[chosenOption];
        }
        return { category, property, reportData };
      }
    });

  return objectChosen;
}


